import axios, { AxiosError } from "axios";
import { PartnerClientId } from "../slices/partnerClientIdsSlice";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAuth } from "firebase/auth";
const SERVER_URL = "https://us-central1-elisyanwealth.cloudfunctions.net/";
const BASE_URL =
  "http://127.0.0.1:5001/elisyanwealth/us-central1/";

// `addPartnerClientId` / `updatePartnerClientId` are migrated to the v2
// endpoints (functions/v2/endpoints/partnerClientIdEndpoints.ts →
// addPartnerClientIds_v2 / updatePartnerClientId_v2), which read/write
// `partnerClientIds_v2`. Pointed at BASE_URL (functions emulator) for
// pre-deploy testing — flip to SERVER_URL after deploying them. The single
// `deletePartnerClientId` thunk still uses SERVER_URL (legacy) — not
// migrated (UI-unreachable, hideDelete).
const PARTNER_V2_DEPLOYED = true;
const PARTNER_V2_URL = PARTNER_V2_DEPLOYED ? SERVER_URL : BASE_URL;

/** ------------------- ASYNC ACTIONS ------------------- **/

// export const fetchPartnerClientIds = createAsyncThunk<
//   { data: PartnerClientId[]; page: number; limit: number; total: number; lastDocId: string | null },
//   { page?: number; limit?: number; businessId?: string; startAfterId?: string | null },
//   { rejectValue: string }
// >(
//   "partnerClientIds/fetchPartnerClientIds",
//   async ({ page = 1, limit = 10, businessId, startAfterId }, thunkAPI) => {
//     try {
//       const response = await axios.get(`${SERVER_URL}getPaginatedPartnerClientIds`, {
//         params: { page, limit, businessId, startAfterId },
//       });
//       console.log("Fetched partner client IDs:", response.data);
//       return response.data;
//     } catch (e) {
//       console.error("Error fetching partner client IDs:", e);
//       if (e instanceof AxiosError && e.response?.data?.message) {
//         return thunkAPI.rejectWithValue(e.response.data.message);
//       }
//       return thunkAPI.rejectWithValue("Unexpected error occurred while fetching data.");
//     }
//   }
// );

// export const addPartnerClientId = createAsyncThunk<
//   PartnerClientId,
//   Omit<PartnerClientId, "id">,
//   { rejectValue: string }
// >("partnerClientIds/add", async (newData, thunkAPI) => {
//   try {
//     const response = await axios.post(`${BASE_URL}addPartnerClientIds`, {partnerClientIds: newData});
//     return response.data;
//   } catch (e) {
//     console.error("Error adding partner client ID:", e);
//     if (e instanceof AxiosError && e.response?.data?.message) {
//       return thunkAPI.rejectWithValue(e.response.data.message);
//     }
//     return thunkAPI.rejectWithValue("Unexpected error occurred while adding data.");
//   }
// });

export const fetchPartnerClientIds = createAsyncThunk<
  {
    data: PartnerClientId[];
    page: number;
    limit: number;
    total: number;
    lastDocId: string | null;
    search?: string; // Add search to return type
  },
  {
    token: string;
    page?: number;
    limit?: number;
    businessId?: string;
    startAfterId?: string | null;
    search?: string;
  },
  { rejectValue: string }
>(
  "partnerClientIds/fetchPartnerClientIds",
  async ({ token, page = 1, limit = 10, businessId, startAfterId, search }, thunkAPI) => {
    try {
      const auth = getAuth();
      const user = auth.currentUser;

      if (!user) {
        return thunkAPI.rejectWithValue("User not authenticated");
      }

      const freshToken = await user.getIdToken();

      // If search is provided, use search endpoint
      if (search && search.length >= 1) {
        const isGlobalSearch = businessId === "OtqyPEBdRE4a5SQL1gob";

        const params: Record<string, string> = { search };
        if (!isGlobalSearch && businessId) {
          params.businessId = businessId;
        }

        const response = await axios.get(
          `${PARTNER_V2_URL}listPartnerClientIds_v2`,
          {
            params,
            headers: {
              Authorization: `Bearer ${freshToken}`,
            },
          }
        );

        const searchData = response.data.data || [];
        return {
          data: searchData,
          page: 1,
          limit: searchData.length,
          total: searchData.length,
          lastDocId: null,
          search, // Include search in return
        };
      }

      // Otherwise, use paginated endpoint
      const response = await axios.get(
        `${PARTNER_V2_URL}listPartnerClientIds_v2`,
        {
          params: { page, limit, businessId, startAfterId },
          headers: {
            Authorization: `Bearer ${freshToken}`,
          },
        }
      );

      console.log("Fetched partner client IDs:", response.data);
      return {
        ...response.data,
        search: undefined, // Explicitly undefined for pagination
      };
    } catch (e) {
      console.error("Error fetching partner client IDs:", e);
      if (e instanceof AxiosError && e.response?.data?.message) {
        return thunkAPI.rejectWithValue(e.response.data.message);
      }
      return thunkAPI.rejectWithValue(
        "Unexpected error occurred while fetching data."
      );
    }
  }
);


// export const fetchPartnerClientIds = createAsyncThunk<
//   {
//     data: PartnerClientId[];
//     page: number;
//     limit: number;
//     total: number;
//     lastDocId: string | null;
//   },
//   {
//     token: string;
//     page?: number;
//     limit?: number;
//     businessId?: string;
//     startAfterId?: string | null;
//     search?: string;
//   },
//   { rejectValue: string }
// >(
//   "partnerClientIds/fetchPartnerClientIds",
//   async ({ token, page = 1, limit = 10, businessId, startAfterId, search }, thunkAPI) => {
//     try {
//       const auth = getAuth();
//       const user = auth.currentUser;

//       if (!user) {
//         return thunkAPI.rejectWithValue("User not authenticated");
//       }

//       const freshToken = await user.getIdToken();

//       // If search is provided, use search endpoint
//       if (search && search.length >= 2) {
//         const isGlobalSearch = businessId === "OtqyPEBdRE4a5SQL1gob";

//         const params: Record<string, string> = { search };
//         if (!isGlobalSearch && businessId) {
//           params.businessId = businessId;
//         }

//         const response = await axios.get(
//           `${BASE_URL}getSearchPaginatedPartnerClientIdsNew`,
//           {
//             params,
//             headers: {
//               Authorization: `Bearer ${freshToken}`,
//             },
//           }
//         );

//         // Format response to match paginated structure
//         const searchData = response.data.data || [];
//         return {
//           data: searchData,
//           page: 1,
//           limit: searchData.length,
//           total: searchData.length,
//           lastDocId: null,
//         };
//       }

//       // Otherwise, use paginated endpoint
//       const response = await axios.get(
//         `${PARTNER_V2_URL}listPartnerClientIds_v2`,
//         {
//           params: { page, limit, businessId, startAfterId },
//           headers: {
//             Authorization: `Bearer ${freshToken}`,
//           },
//         }
//       );

//       console.log("Fetched partner client IDs:", response.data);
//       return response.data;
//     } catch (e) {
//       console.error("Error fetching partner client IDs:", e);
//       if (e instanceof AxiosError && e.response?.data?.message) {
//         return thunkAPI.rejectWithValue(e.response.data.message);
//       }
//       return thunkAPI.rejectWithValue(
//         "Unexpected error occurred while fetching data."
//       );
//     }
//   }
// );

// export const fetchPartnerClientIds = createAsyncThunk<
//   {
//     data: PartnerClientId[];
//     page: number;
//     limit: number;
//     total: number;
//     lastDocId: string | null;
//   },
//   {
//     token: string;
//     page?: number;
//     limit?: number;
//     businessId?: string;
//     startAfterId?: string | null;
//   },
//   { rejectValue: string }
// >(
//   "partnerClientIds/fetchPartnerClientIds",
//   async ({ token, page = 1, limit = 10, businessId, startAfterId }, thunkAPI) => {
//     try {
//         const auth = getAuth();
//         const user = auth.currentUser;
        
//         if (!user) {
//           return thunkAPI.rejectWithValue('User not authenticated');
//         }
        
//         // Get fresh token (Firebase automatically refreshes if needed)
//         const token = await user.getIdToken();
//       const response = await axios.get(`${PARTNER_V2_URL}listPartnerClientIds_v2`, {
//         params: { page, limit, businessId, startAfterId },
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       console.log("Fetched partner client IDs:", response.data);
//       return response.data;
//     } catch (e) {
//       console.error("Error fetching partner client IDs:", e);
//       if (e instanceof AxiosError && e.response?.data?.message) {
//         return thunkAPI.rejectWithValue(e.response.data.message);
//       }
//       return thunkAPI.rejectWithValue(
//         "Unexpected error occurred while fetching data."
//       );
//     }
//   }
// );

export const addPartnerClientId = createAsyncThunk<
  PartnerClientId,
  {token: string; newData: Omit<PartnerClientId, "id">},
  { rejectValue: string }
>("partnerClientIds/add", async ({token, newData}, thunkAPI) => {
  try {
    // 🔥 Send token in Authorization header
    const auth = getAuth();
    const user = auth.currentUser;
    
    if (!user) {
        return thunkAPI.rejectWithValue('User not authenticated');
    }
    
    // Get fresh token (Firebase automatically refreshes if needed)
    const token = await user.getIdToken();
    const response = await axios.post(
      `${PARTNER_V2_URL}addPartnerClientIds_v2`,
      { partnerClientIds: newData },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (e) {
    console.error("Error adding partner client ID:", e);
    if (e instanceof AxiosError && e.response?.data?.message) {
      return thunkAPI.rejectWithValue(e.response.data.message);
    }
    return thunkAPI.rejectWithValue("Unexpected error occurred while adding data.");
  }
});

// A clientId change here is a RENAME of the partnerClientId bucket itself
// (functions/v2/models/PartnerClientId.ts's rename()) — not the per-client
// reassignment AddClientIDModal does. v2 handles the "keep users in sync"
// part inside the same Firestore transaction as the rename: it moves the
// bucket's doc to the new deterministic id (`${businessId}_${clientId}`)
// and, in that same transaction, updates every linked user's `clientId`
// field (and `partnerClientId` ref, since the doc moved). There's no
// Firestore feature that keeps a denormalized field in sync on its own
// (no cascading update / foreign key) — this transactional write-through is
// the mechanism; the alternative would be a Cloud Function trigger on
// partnerClientIds_v2 writes, which is NOT used here on purpose: it would
// only run after the request that changed clientId already committed
// (eventually consistent — the API response could return before every user
// doc is updated), and duplicates the dup-check logic that already has to
// live in rename() anyway. updatePartnerClientId_v2 does this for both
// clientId AND type/users_limit changes in one call; type/users_limit alone
// go through the plain (non-renaming) update().
export const updatePartnerClientId = createAsyncThunk<
  PartnerClientId,
  { token: string; id: string; updates: Partial<PartnerClientId> },
  { rejectValue: string }
>("partnerClientIds/update", async ({ id, updates }, thunkAPI) => {
  try {
    const authUser = getAuth().currentUser;
    if (!authUser) {
      return thunkAPI.rejectWithValue('User not authenticated');
    }
    const token = await authUser.getIdToken();

    const response = await axios.post(
      `${PARTNER_V2_URL}updatePartnerClientId_v2`,
      {
        id,
        clientId: updates.clientId,
        type: updates.type,
        users_limit: updates.users_limit,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // v2 returns `business` (the owner's id) — the frontend PartnerClientId
    // shape (and the list endpoint's own response) uses `businessId`.
    const { business, ...rest } = response.data?.data || {};
    return { ...rest, businessId: business ?? updates.businessId } as PartnerClientId;
  } catch (e) {
    console.error("Error updating partner client ID:", e);
    if (e instanceof AxiosError && e.response?.data?.message) {
      return thunkAPI.rejectWithValue(e.response.data.message);
    }
    return thunkAPI.rejectWithValue("Unexpected error occurred while updating data.");
  }
});

export const deletePartnerClientId = createAsyncThunk<
  string,
  {id: string; token: string},
  { rejectValue: string }
>("partnerClientIds/delete", async ({id, token}, thunkAPI) => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;
    
    if (!user) {
        return thunkAPI.rejectWithValue('User not authenticated');
    }
    
    // Get fresh token (Firebase automatically refreshes if needed)
    const token = await user.getIdToken();
    await axios.delete(`${SERVER_URL}deletePartnerClientId`, { params: { partnerClientId: id } ,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
    return id;
  } catch (e) {
    console.error("Error deleting partner client ID:", e);
    if (e instanceof AxiosError && e.response?.data?.message) {
      return thunkAPI.rejectWithValue(e.response.data.message);
    }
    return thunkAPI.rejectWithValue("Unexpected error occurred while deleting data.");
  }
});

/**
 * "Cancel" a partner client ID — the v2 "reset to elisyan" flow
 * (cancelPartnerClientId_v2). Freezes the client ID so no one else can sign
 * up through it, migrates every user who did back to elisyan (revoking their
 * premium entitlement + unassigning advisors — REAL RevenueCat/AWS calls),
 * and issues one replacement referral code for the cohort.
 *
 * Sends the legacy row id AND businessId+clientId so the endpoint can
 * resolve the migrated (deterministic-id) doc either way.
 */
export const cancelPartnerClientId = createAsyncThunk<
  { id: string; replacementCode?: { id: string; code: string }; affectedUserIds?: string[] },
  { row: { id: string; businessId?: string; clientId: string } },
  { rejectValue: string }
>("partnerClientIds/cancel", async ({ row }, thunkAPI) => {
  try {
    const authUser = getAuth().currentUser;
    if (!authUser) return thunkAPI.rejectWithValue("User not authenticated");
    const token = await authUser.getIdToken();

    const state = thunkAPI.getState() as { auth_slice?: { user?: { id?: string } } };
    const adminUuid = state?.auth_slice?.user?.id || authUser.uid;

    const res = await axios.post(
      `${PARTNER_V2_URL}cancelPartnerClientId_v2`,
      { id: row.id, businessId: row.businessId, clientId: row.clientId, adminUuid },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return { id: row.id, ...(res.data?.data ?? {}) };
  } catch (e) {
    console.error("Error canceling partner client ID:", e);
    if (e instanceof AxiosError && e.response?.data?.message) {
      return thunkAPI.rejectWithValue(e.response.data.message);
    }
    return thunkAPI.rejectWithValue("Unexpected error occurred while canceling.");
  }
});
